import * as React from 'react';
import {Fragment, ReactElement} from 'react';
import {BooleanField, Datagrid, EditButton, List, ListProps, useTranslate} from 'react-admin';
import {Route} from 'react-router';

import VideoFilter from "./VideoFilter";
import VideoEdit from "./VideoEdit";
import SideDrawer from "../../components/list/SideDrawer";
import TextField from "../../components/list/TextField";
import ListActions from "../../components/list/ListActions";
import {Typography} from "@material-ui/core";


const VideoList = (props: ListProps): ReactElement => {
    const translate = useTranslate();

    return (
        <Fragment>
            <Typography variant={'h6'}>{translate('resources.admin/videos.name')}</Typography>
            <List {...props} filters={<VideoFilter/>} sort={{field: 'id', order: 'DESC'}} actions={<ListActions/>}>
                <Datagrid>
                    <TextField source="id"/>
                    <BooleanField source="is_active" />
                    <BooleanField source="is_recommended" />
                    <BooleanField source="is_highlighted" />
                    <TextField source="title"/>
                    <EditButton/>
                </Datagrid>
            </List>
            <Route path={`${props.basePath}/:id`}>
                {({match}) => {
                    const isMatch = !!(match && match.params && match.params.id !== 'create');
                    return (
                        <SideDrawer key="video_sidedrawer" open={isMatch} basePath={props.basePath ?? ''}>
                            {isMatch && (
                                <VideoEdit id={match && isMatch ? match.params.id : undefined}{...props}/>
                            )}
                        </SideDrawer>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default VideoList;
